/**
 * 收藏单选择规格
 */
import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import { Icon } from '@cps'
import './index.scss'
interface IProps {
  product: IMallFavoProduct;
  onDelete?: (scaleNo: any) => void;
  onChange?: (data: any, index: number) => void;
}

const ProductScales: React.FC<IProps> = ({ product, onDelete, onChange }) => {
  const { selectScales = [] } = product
  /** 再选一款按钮显示控制 */
  const [isAdd, setAdd] = useState(true)

  useEffect(() => {
    setAddBtn()
  }, [selectScales])
  const handleTackIt = (scaleNo: string = '', index: number) => {
    if (index < 0) {
      index = selectScales.length > 0 ? selectScales.length : 0
    }
    onChange(scaleNo, index)
    setAddBtn()
  }
  const setAddBtn = () => {
    if (selectScales.length >= product.scales.length) {
      setAdd(false)
    } else {
      setAdd(true)
    }
  }
  return (
    <div className='mall-scales-wrapper'>
      {
        (selectScales || []).map((scale, index) => {
          return (
            <div className='scales-item-wrapper' key={scale.no}>
              <div className='scales-item-wrap' onClick={() => handleTackIt(scale.no, index)}>
                <div className='scales-item-left'>{scale.name}</div>
                <div className='scales-item-right'>
                  <div className='amount'>x{scale.selectCnt}</div>
                  <Icon name='chevron-right' />
                </div>
              </div>
              <div className='delete-wrap'>
                {selectScales.length > 1 && <Icon name='close' onClick={() => onDelete && onDelete(scale.no)} />}
              </div>
            </div>
          )
        })
      }
      {isAdd && (
        selectScales.length > 0 ? (
          <div className='scales-add-wrapper' onClick={() => handleTackIt('', -1)}>
            <span>{i18n.t('mall.addScaleToFavo')}</span>
            <Icon name='add' />
          </div>
        ) : (
          <div className='scales-item-wrapper default'>
            <div className='scales-item-wrap' onClick={() => handleTackIt('', -1)}>
              <div className='scales-item-left'>{i18n.t('mall.selectScale')}</div>
              <div className='scales-item-right'>
                <Icon name='chevron-right' />
              </div>
            </div>
            <div className='delete-wrap'></div>
          </div>
        )
      )}
    </div>
  )
}

export default observer(ProductScales)
